/** Client-side helpers for GuidePage MetaHead / JSON-LD props. */

export function parseGuideKeywords(raw) {
  return String(raw || '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

export function extractFaqsFromPageCopy(blocks) {
  const faqBlock = (blocks || []).find((b) => b?.type === 'faq');
  const items = Array.isArray(faqBlock?.items) ? faqBlock.items : [];
  return items
    .map((row) => {
      const question = String(row?.q || row?.question || row?.title || '').trim();
      const answer = String(row?.a || row?.answer || row?.description || row?.copy || '').trim();
      if (!question || !answer) return null;
      return { question, answer };
    })
    .filter(Boolean);
}

export function extractHowToStepsFromPageCopy(blocks) {
  const stepsBlock = (blocks || []).find((b) => b?.type === 'steps');
  const items = Array.isArray(stepsBlock?.items) ? stepsBlock.items : (blocks || []).filter(block => block?.type === 'section' && /^\d+\.\s/.test(block.title || ''));
  return items
    .map((row) => {
      const name = String(row?.title || row?.label || '').trim();
      const text = String(row?.description || row?.copy || row?.text || '').trim();
      if (!name && !text) return null;
      return { name: name || text, text: text || name };
    })
    .filter(Boolean);
}
